// MVP runtime flags — import before mock data / services.

const pre = typeof window !== 'undefined' ? window : {};

export const USE_REAL_TENANTS_API = pre.USE_REAL_TENANTS_API !== false;
export const USE_MOCK_TENANTS = pre.USE_MOCK_TENANTS === true;
export const USE_REAL_NOTIFICATIONS_API = pre.USE_REAL_NOTIFICATIONS_API !== false;
export const USE_MOCK_NOTIFICATIONS = pre.USE_MOCK_NOTIFICATIONS === true;
export const USE_REAL_BILLING_API = pre.USE_REAL_BILLING_API !== false;
export const USE_MOCK_BILLING = pre.USE_MOCK_BILLING === true;
export const USE_REAL_REPAIRS_API = pre.USE_REAL_REPAIRS_API === true;
export const USE_MOCK_REPAIRS = pre.USE_MOCK_REPAIRS === true;

export const FEATURE_SUPPORT_MODULES = pre.FEATURE_SUPPORT_MODULES === true;
export const FEATURE_REPAIRS_MODULE = pre.FEATURE_REPAIRS_MODULE === true;
export const FEATURE_OBSERVABILITY = pre.FEATURE_OBSERVABILITY === true;
export const FEATURE_INTEGRATIONS = pre.FEATURE_INTEGRATIONS === true;
export const FEATURE_IMPERSONATION = pre.FEATURE_IMPERSONATION === true;

export const SA_MVP_LEGACY_ROUTES = {
  usuarios: 'equipe',
};

export const SA_MVP_HIDDEN_ROUTES = new Set([
  'tickets', 'knowledge-base', 'support-reports', 'atendimento',
]);

export function saShouldUseMockTenants() {
  if (USE_MOCK_TENANTS === true) return true;
  if (USE_REAL_TENANTS_API === false) return true;
  return false;
}

export function saIsRealTenantsMode() {
  return !saShouldUseMockTenants();
}

export function saShouldUseMockNotifications() {
  if (USE_MOCK_NOTIFICATIONS === true) return true;
  if (USE_REAL_NOTIFICATIONS_API === false) return true;
  return false;
}

export function saIsRealNotificationsMode() {
  return !saShouldUseMockNotifications();
}

export function saShouldUseMockBilling() {
  if (USE_MOCK_BILLING === true) return true;
  if (USE_REAL_BILLING_API === false) return true;
  return false;
}

export function saIsRealBillingMode() {
  return !saShouldUseMockBilling();
}

export function saShouldUseMockRepairs() {
  if (USE_MOCK_REPAIRS === true) return true;
  if (USE_REAL_REPAIRS_API !== true) return true;
  return false;
}

export function saIsRealRepairsMode() {
  return !saShouldUseMockRepairs();
}

export function saResolveLegacyRoute(page) {
  if (!page) return page;
  return SA_MVP_LEGACY_ROUTES[page] || page;
}

export function saIsRouteAllowedInMvp(page) {
  if (!page) return false;
  const resolved = saResolveLegacyRoute(page);
  if (SA_MVP_HIDDEN_ROUTES.has(resolved)) return false;
  if (resolved === 'integrations' && !FEATURE_INTEGRATIONS) return false;
  if (resolved === 'observabilidade' && !FEATURE_OBSERVABILITY) return false;
  return true;
}

export function saIsPrototypeRoute(page) {
  if (page === 'integrations') return !FEATURE_INTEGRATIONS;
  if (page === 'observabilidade') return !FEATURE_OBSERVABILITY;
  if (page === 'repairs') return !FEATURE_REPAIRS_MODULE;
  return false;
}

export const SA_SHOW_FUTURE_PAGES_KEY = 'tezus-sa-show-future-pages';

export function saIsLocalHost(hostname) {
  const host = String(
    hostname != null
      ? hostname
      : (typeof window !== 'undefined' ? window.location.hostname : '')
  ).toLowerCase();
  if (!host) return false;
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (host === 'manage.localhost' || host.endsWith('.localhost')) return true;
  return false;
}

export function saIsFuturePage(page) {
  if (!page) return false;
  const resolved = saResolveLegacyRoute(page);
  // Dead-end / legado fora do MVP operacional (placeholder → Billing / Planos & Permissões).
  if (resolved === 'planos') return true;
  if (resolved === 'tech-spec') return true;
  // Inbox ainda é protótipo com mock local (sem UX operacional confiável em stage/prod).
  // Visível por padrão em localhost; em stage/prod só com "Mostrar páginas futuras".
  if (resolved === 'notificacoes-ops') return true;
  return saIsPrototypeRoute(resolved);
}

export function saGetShowFuturePages() {
  try {
    if (typeof localStorage !== 'undefined') {
      const raw = localStorage.getItem(SA_SHOW_FUTURE_PAGES_KEY);
      if (raw === 'true') return true;
      if (raw === 'false') return false;
    }
  } catch (e) { /* ignore */ }
  return saIsLocalHost();
}

export function saSetShowFuturePages(value) {
  const next = value === true;
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(SA_SHOW_FUTURE_PAGES_KEY, next ? 'true' : 'false');
    }
  } catch (e) { /* ignore */ }
  return next;
}

/** Pages that are entirely toast/local mock — hidden in operational UI until a real API exists. */
export const SA_MOCK_ONLY_PAGES = new Set(['config', 'perfis']);

export function saIsMockOnlyPage(page) {
  if (!page) return false;
  const resolved = saResolveLegacyRoute(page);
  return SA_MOCK_ONLY_PAGES.has(resolved);
}
